<template>
  <div>
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="打款平台" prop="payPlatForm">
            <el-select
              v-model="ruleForm.payPlatForm"
              placeholder="请选择打款平台">
              <el-option
                :label="item.dictValue"
                :value="item.dictCode"
                v-for="(item, index) in promotionDict.tax_pay_plat_form"
                :key="index"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="打款公司" prop="payCompany">
            <el-select
              v-model="ruleForm.payCompany"
              placeholder="请选择打款公司">
              <el-option
                :label="item.dictValue"
                :value="item.dictCode"
                v-for="(item, index) in promotionDict.tax_pay_company"
                :key="index"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="打款凭证命名规则" prop="ruleCode">
            <el-select
              v-model="ruleForm.ruleCode"
              placeholder="请选择打款凭证命名规则">
              <el-option
                :label="item.dictValue"
                :value="item.dictCode"
                v-for="(item, index) in promotionDict.tax_rule_type"
                :key="index"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="流水单号" prop="taxSeqNo">
            <el-input v-model="ruleForm.taxSeqNo"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <!-- 文件上传区域 -->
      <div class="upload-section">
        <el-upload
          class="upload-demo"
          drag
          action="1"
          :headers="{
            loginUserToken: Storage.l.get('TokenKey'),
          }"
          :show-file-list="true"
          :on-exceed="handleExceed"
          :before-upload="beforeUpload"
          :on-preview="handlePreview"
          :on-change="handleChange"
          :on-remove="handleRemove"
          :before-remove="beforeRemove"
          :on-success="handleSuccess"
          :limit="10"
          :accept="accept"
          :file-list="fileList"
          :auto-upload="false"
          :multiple="true"
          ref="upload">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          <div class="el-upload__tip" slot="tip">
            仅支持ZIP文件，单文件不超过2GB，支持大文件上传
          </div>
        </el-upload>

        <!-- 上传进度显示 -->
        <div v-if="uploadProgress.visible" class="upload-progress">
          <div class="progress-header">
            <span>上传进度</span>
            <el-button
              type="text"
              @click="pauseUpload"
              v-if="!uploadProgress.isPaused && uploadProgress.uploading">
              暂停
            </el-button>
            <el-button
              type="text"
              @click="resumeUpload"
              v-if="uploadProgress.isPaused && uploadProgress.uploading">
              继续
            </el-button>
            <el-button
              type="text"
              @click="cancelUpload"
              v-if="uploadProgress.uploading">
              取消
            </el-button>
          </div>

          <div
            class="file-progress"
            v-for="file in uploadProgress.files"
            :key="file.uid">
            <div class="file-info">
              <span class="file-name">{{ file.name }}</span>
              <span class="file-status">{{ getStatusText(file) }}</span>
              <span class="upload-mode" v-if="file.useChunk">(分片上传)</span>
              <span class="upload-mode" v-else>(直接上传)</span>
            </div>
            <div class="progress-details">
              <el-progress
                :percentage="file.percentage"
                :status="getProgressStatus(file)"
                :show-text="false">
              </el-progress>
              <div class="progress-text">
                <span
                  >{{ formatSize(file.uploadedSize) }} /
                  {{ formatSize(file.totalSize) }}</span
                >
                <span>{{ file.percentage }}%</span>
              </div>
            </div>
            <div v-if="file.speed" class="upload-speed">
              速度: {{ formatSpeed(file.speed) }}
            </div>
          </div>
        </div>
      </div>

      <div v-html="propsObj.exportMessage" class="wsMessageBox"></div>
      <div class="dialog-footer">
        <el-button
          type="primary"
          :loading="uploadLoading"
          @click="startUploadProcess"
          v-if="!propsObj.isExport && propsObj.code !== 'view_prograss'"
          size="small"
          :disabled="!hasValidFiles">
          开始上传
        </el-button>
        <el-button
          type="primary"
          @click="download_originfile('fail')"
          v-if="
            !propsObj.isExport &&
            propsObj.code === 'view_prograss' &&
            propsObj.row.filePathAsImportFail
          "
          size="small">
          下载失败文件
        </el-button>
        <el-button
          type="danger"
          @click="dialog_btnClose"
          size="small"
          icon="el-icon-close">
          关闭
        </el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import ReconnectingWebSocket from 'reconnecting-websocket';
import request, { websocketUrl } from '@/found/utils/request';
import TablePage from '@/found/components/table_page';
import Storage from '@/found/utils/storage';
import SparkMD5 from 'spark-md5';
import axios from 'axios';

export default {
  name: 'ExportModals',
  extends: TablePage,
  props: {
    propsObj: Object,
  },
  data() {
    return {
      rules: {
        payPlatForm: [
          { required: true, message: '请选择打款平台', trigger: 'change' },
        ],
        payCompany: [
          { required: true, message: '请选择打款公司', trigger: 'change' },
        ],
        ruleCode: [
          {
            required: true,
            message: '请选择打款凭证命名规则',
            trigger: 'change',
          },
        ],
      },
      ruleForm: {
        payPlatForm: '',
        payCompany: '',
        ruleCode: '',
        taxSeqNo: '',
      },
      promotionDict: {
        tax_pay_plat_form: [],
        tax_pay_company: [],
        tax_rule_type: [],
      },
      Storage,
      fileList: [],
      files: [],
      uploadLoading: false,
      accept: '.zip,.ZIP,application/zip,application/x-zip-compressed',

      // 切片上传相关
      chunkSize: 2 * 1024 * 1024, // 10MB 切片大小
      chunkThreshold: 10 * 1024 * 1024, // 10MB 以上才分片
      concurrentUploads: 1, // 并发上传数
      uploadProgress: {
        visible: false,
        uploading: false,
        isPaused: false,
        files: [], // 每个文件的上传进度
      },
      uploadControllers: new Map(), // 存储取消控制器
      pendingChunksMap: new Map(), // 存储待上传的切片
      websocket: null,
      sid: '',
    };
  },
  computed: {
    hasValidFiles() {
      return this.files.length > 0;
    },
  },
  created() {
    this.createWebsocket();
    this.getBatchDictSelect();
    this.initFromProps();
  },
  watch: {
    propsObj: {
      deep: true,
      handler(val) {
        console.log('导入导出组件：', val);
        this.createWebsocket();
        this.initFromProps();
      },
    },
  },
  methods: {
    initFromProps() {
      if (
        this.propsObj
        && Object.keys(this.propsObj).length > 0
        && !this.propsObj.isExport
      ) {
        const arr = [];
        if (this.propsObj.row) {
          arr.push({
            name: this.propsObj.row.fileName,
            url: this.propsObj.row.filePath,
          });
        }
        this.fileList = arr;
      }
    },

    // 获取数据字典
    getBatchDictSelect() {
      const params = ['tax_pay_plat_form', 'tax_pay_company', 'tax_rule_type'];
      request.post('/mdm/mdmdictdata/batchDictSelect', params).then((res) => {
        if (res.success) {
          this.promotionDict = {
            tax_pay_plat_form: res.result.tax_pay_plat_form,
            tax_pay_company: res.result.tax_pay_company,
            tax_rule_type: res.result.tax_rule_type,
          };
        }
      });
    },

    // 创建取消令牌
    createCancelToken() {
      const source = axios.CancelToken.source();
      return {
        token: source.token,
        cancel: source.cancel,
      };
    },

    // 开始上传流程
    async startUploadProcess() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (!valid) return;

        if (!this.files.length) {
          this.$message.error('请先上传文件');
          return;
        }

        this.uploadLoading = true;
        this.uploadProgress.visible = true;
        this.uploadProgress.uploading = true;
        this.uploadProgress.isPaused = false;

        // 初始化上传进度
        this.uploadProgress.files = this.files.map((file) => ({
          uid: file.uid,
          name: file.name,
          totalSize: file.size,
          uploadedSize: 0,
          percentage: 0,
          status: 'pending',
          chunks: [],
          speed: 0,
          startTime: null,
          useChunk: file.size > this.chunkThreshold, // 判断是否使用分片上传
        }));

        try {
          // 使用 Promise.all 并行上传文件
          const uploadPromises = this.uploadProgress.files.map(
            (fileProgress) => {
              if (this.uploadProgress.isPaused) {
                return Promise.resolve();
              }

              const file = this.files.find((f) => f.uid === fileProgress.uid);
              if (file) {
                // 创建新的对象而不是修改参数
                const updatedFileProgress = {
                  ...fileProgress,
                  status: 'uploading',
                  startTime: Date.now(),
                };

                // 更新列表中的文件进度
                this.updateFileProgressInList(updatedFileProgress);

                // 根据文件大小选择上传方式
                if (updatedFileProgress.useChunk) {
                  return this.uploadFileWithChunks(file, updatedFileProgress);
                }
                return this.uploadSingleFile(file, updatedFileProgress);
              }
              return Promise.resolve();
            },
          );

          await Promise.all(uploadPromises);

          if (!this.uploadProgress.isPaused) {
            this.$message.success('所有文件上传完成');
            // setTimeout(() => {
            //   this.$emit('onClose');
            // }, 1000);
          }
        } catch (error) {
          console.error('上传失败:', error);
          if (error.message !== '请求被取消') {
            this.$message.error(`上传失败: ${error.message}`);
          }
        } finally {
          this.uploadLoading = false;
          this.uploadProgress.uploading = false;
        }
      });
    },

    // 上传单个文件（小文件直接上传）
    async uploadSingleFile(file, fileProgress) {
      const formData = new FormData();
      const fileMd5 = await this.calculateFileHash(file);
      formData.append('file', file);
      formData.append('fileName', file.name);
      formData.append('chunk', 1); // 第几个分片
      formData.append('chunks', 1); // 总分片数
      formData.append('fileMd5', fileMd5); // 文件MD5

      // 添加上传参数
      const {
        ruleCode, taxSeqNo, payPlatForm, payCompany,
      } = this.ruleForm;
      const urlParam = `?configCode=${this.propsObj.configCode}&webSocketClientId=${this.sid}&taxSeqNo=${taxSeqNo}&payPlatForm=${payPlatForm}&payCompany=${payCompany}&ruleCode=${ruleCode}`;

      // 创建取消令牌
      const cancelToken = this.createCancelToken();
      this.uploadControllers.set(file.uid, cancelToken.cancel);

      try {
        const startTime = Date.now();

        await request.postform(
          `/tax/v1/terminalCash/api/uploadZip${urlParam}`,
          formData,
          {
            cancelToken: cancelToken.token,
            onUploadProgress: (progressEvent) => {
              if (progressEvent.lengthComputable) {
                const { loaded } = progressEvent;
                const { total } = progressEvent;
                const percentage = Math.round((loaded / total) * 100);

                // 计算上传速度
                const currentTime = Date.now();
                const timeDiff = (currentTime - startTime) / 1000;
                let speed = 0;
                if (timeDiff > 0) {
                  speed = loaded / timeDiff;
                }

                const updatedFileProgress = {
                  ...fileProgress,
                  uploadedSize: loaded,
                  percentage,
                  speed,
                };
                this.updateFileProgressInList(updatedFileProgress);
              }
            },
          },
        );

        const completedFileProgress = {
          ...fileProgress,
          status: 'completed',
          percentage: 100,
          uploadedSize: file.size,
        };
        this.updateFileProgressInList(completedFileProgress);
      } catch (error) {
        if (!axios.isCancel(error)) {
          const failedFileProgress = {
            ...fileProgress,
            status: 'error',
          };
          this.updateFileProgressInList(failedFileProgress);
          throw error;
        }
      } finally {
        this.uploadControllers.delete(file.uid);
      }
    },

    // 上传单个文件的切片（大文件分片上传）
    async uploadFileWithChunks(file, fileProgress) {
      // 计算文件MD5（用于断点续传）
      const fileMd5 = await this.calculateFileHash(file);
      const chunks = this.createFileChunks(file, fileMd5);

      const newFileProgress = {
        ...fileProgress,
        chunks: chunks.map((chunk, index) => ({
          index: index + 1, // chunk从1开始
          hash: `${fileMd5}-${index}`,
          chunk: chunk.chunk,
          size: chunk.size,
          percentage: 0,
          uploaded: false,
        })),
      };

      // 更新文件进度对象
      this.updateFileProgressInList(newFileProgress);

      // 检查已上传的切片(查询已上传的分片文件，此功能先注释)
      // await this.checkUploadedChunks(file, fileMd5, newFileProgress);

      // 存储待上传的切片
      const pendingChunks = newFileProgress.chunks.filter(
        (chunk) => !chunk.uploaded,
      );
      this.pendingChunksMap.set(fileProgress.uid, pendingChunks);

      // 上传剩余切片
      await this.uploadChunks(file, fileMd5, newFileProgress);

      // 所有切片上传完成，通知合并(合并分片文件，此功能先注释)
      // const updatedProgress = this.uploadProgress.files.find(
      //   (f) => f.uid === fileProgress.uid,
      // );
      // if (
      //   updatedProgress
      //   && updatedProgress.chunks.every((chunk) => chunk.uploaded)
      // ) {
      //   await this.mergeFileChunks(file, fileMd5, updatedProgress);
      // }
    },

    // 计算文件MD5
    calculateFileHash(file) {
      return new Promise((resolve) => {
        const spark = new SparkMD5.ArrayBuffer();
        const fileReader = new FileReader();
        const chunkSize = 10 * 1024 * 1024; // 10MB chunks for hash calculation
        const chunks = Math.ceil(file.size / chunkSize);
        let currentChunk = 0;

        const loadNext = () => {
          const start = currentChunk * chunkSize;
          const end = Math.min(start + chunkSize, file.size);
          fileReader.readAsArrayBuffer(file.slice(start, end));
        };

        fileReader.onload = (e) => {
          spark.append(e.target.result);
          currentChunk += 1;
          if (currentChunk < chunks) {
            loadNext();
          } else {
            resolve(spark.end());
          }
        };

        loadNext();
      });
    },

    // 创建文件切片
    createFileChunks(file, fileMd5) {
      const chunks = [];
      let currentPosition = 0;
      let chunkIndex = 0;

      while (currentPosition < file.size) {
        const chunk = file.slice(
          currentPosition,
          currentPosition + this.chunkSize,
        );
        chunks.push({
          hash: `${fileMd5}-${chunkIndex}`,
          index: chunkIndex,
          chunk,
          size: chunk.size,
        });
        currentPosition += this.chunkSize;
        chunkIndex += 1;
      }

      return chunks;
    },

    // 检查已上传的切片
    async checkUploadedChunks(file, fileMd5, fileProgress) {
      try {
        const cancelToken = this.createCancelToken();
        this.uploadControllers.set(`${fileMd5}-check`, cancelToken.cancel);

        const response = await request.post(
          '/tax/v1/terminalCash/api/checkChunks',
          {
            fileName: file.name,
            fileMd5,
            chunks: fileProgress.chunks.length,
          },
          {
            cancelToken: cancelToken.token,
          },
        );

        if (response.success && response.result.uploadedChunks) {
          let totalUploadedSize = 0;
          const updatedChunks = fileProgress.chunks.map((chunk) => {
            if (response.result.uploadedChunks.includes(chunk.index)) {
              totalUploadedSize += chunk.size;
              return {
                ...chunk,
                uploaded: true,
                percentage: 100,
              };
            }
            return chunk;
          });

          // 更新文件进度
          const updatedFileProgress = {
            ...fileProgress,
            chunks: updatedChunks,
            uploadedSize: totalUploadedSize,
          };

          this.updateFileProgressInList(updatedFileProgress);
          this.calculateFileProgress(updatedFileProgress);
        }
      } catch (error) {
        if (!axios.isCancel(error)) {
          console.warn('检查已上传切片失败:', error);
        }
      } finally {
        this.uploadControllers.delete(`${fileMd5}-check`);
      }
    },

    // 上传切片
    async uploadChunks(file, fileMd5, fileProgress) {
      const pendingChunks = this.pendingChunksMap.get(fileProgress.uid) || [];
      if (pendingChunks.length === 0) return;

      // 创建共享的待上传切片队列（使用数组引用）
      const sharedPendingChunks = [...pendingChunks];

      // 创建并发池
      const workers = [];
      for (let i = 0; i < this.concurrentUploads; i += 1) {
        workers.push(
          this.uploadChunkWorker(file, fileMd5, fileProgress, sharedPendingChunks),
        );
      }

      await Promise.all(workers);

      // 更新待上传切片映射
      this.pendingChunksMap.set(fileProgress.uid, sharedPendingChunks);
    },

    // 切片上传工作器
    async uploadChunkWorker(file, fileMd5, fileProgress, sharedPendingChunks) {
      const processChunk = async () => {
        if (this.uploadProgress.isPaused) {
          // 暂停状态，等待恢复
          await new Promise((resolve) => {
            const checkResume = () => {
              if (!this.uploadProgress.isPaused) {
                resolve();
              } else {
                setTimeout(checkResume, 100);
              }
            };
            checkResume();
          });
        }

        // 从共享队列中获取切片（使用 shift 确保每个工作器获取不同的切片）
        const chunkData = sharedPendingChunks.shift();
        console.log('分片内容：', chunkData);
        if (!chunkData) {
          return;
        }

        await this.uploadSingleChunk(file, fileMd5, chunkData, fileProgress);
        await processChunk(); // 递归处理下一个切片
      };

      await processChunk();
    },

    // 上传单个切片
    async uploadSingleChunk(file, fileMd5, chunkData, fileProgress) {
      console.log('文件上传：', file, fileMd5, chunkData, fileProgress);
      const formData = new FormData();
      formData.append('file', chunkData.chunk);
      formData.append('fileName', file.name);
      formData.append('chunk', chunkData.index.toString()); // 第几个分片（使用切片对象中的 index）
      formData.append('chunks', fileProgress.chunks.length.toString()); // 总分片数
      formData.append('fileMd5', fileMd5); // 文件MD5

      // 创建取消令牌
      const cancelToken = this.createCancelToken();
      this.uploadControllers.set(chunkData.hash, cancelToken.cancel);

      try {
        const startTime = Date.now();
        const {
          ruleCode, taxSeqNo, payPlatForm, payCompany,
        } = this.ruleForm;
        const urlParam = `?configCode=${this.propsObj.configCode}&webSocketClientId=${this.sid}&taxSeqNo=${taxSeqNo}&payPlatForm=${payPlatForm}&payCompany=${payCompany}&ruleCode=${ruleCode}`;

        await request.postform(
          `/tax/v1/terminalCash/api/uploadZip${urlParam}`,
          formData,
          {
            cancelToken: cancelToken.token,
            onUploadProgress: (progressEvent) => {
              if (progressEvent.lengthComputable) {
                const chunkLoaded = progressEvent.loaded;
                const updatedChunkData = {
                  ...chunkData,
                  percentage: Math.round((chunkLoaded / chunkData.size) * 100),
                };

                // 计算上传速度
                const currentTime = Date.now();
                const timeDiff = (currentTime - startTime) / 1000;
                if (timeDiff > 0) {
                  updatedChunkData.speed = chunkLoaded / timeDiff;
                }

                this.updateChunkProgress(fileProgress, updatedChunkData);
              }
            },
          },
        );

        const completedChunkData = {
          ...chunkData,
          uploaded: true,
        };

        this.updateChunkProgress(
          fileProgress,
          completedChunkData,
          chunkData.size,
        );
      } catch (error) {
        if (!axios.isCancel(error)) {
          // 上传失败，将切片重新放回队列
          sharedPendingChunks.unshift(chunkData);
          console.error(`切片 ${chunkData.index} 上传失败:`, error);
          throw error;
        }
      } finally {
        this.uploadControllers.delete(chunkData.hash);
      }
    },

    // 更新切片进度
    updateChunkProgress(fileProgress, chunkData, uploadedSize = null) {
      const fileProgressIndex = this.uploadProgress.files.findIndex(
        (f) => f.uid === fileProgress.uid,
      );
      if (fileProgressIndex === -1) return;

      const currentFileProgress = this.uploadProgress.files[fileProgressIndex];
      const updatedChunks = currentFileProgress.chunks.map((chunk) => (chunk.index === chunkData.index ? { ...chunk, ...chunkData } : chunk));

      // 计算总上传大小
      const totalUploadedSize = uploadedSize
        ? currentFileProgress.uploadedSize + uploadedSize
        : updatedChunks.reduce(
          (total, chunk) => total + (chunk.uploaded ? chunk.size : 0),
          0,
        );

      const updatedFileProgress = {
        ...currentFileProgress,
        chunks: updatedChunks,
        uploadedSize: totalUploadedSize,
      };

      this.updateFileProgressInList(updatedFileProgress);
      this.calculateFileProgress(updatedFileProgress);
    },

    // 更新文件进度列表
    updateFileProgressInList(fileProgress) {
      const fileProgressIndex = this.uploadProgress.files.findIndex(
        (f) => f.uid === fileProgress.uid,
      );
      if (fileProgressIndex !== -1) {
        this.uploadProgress.files.splice(fileProgressIndex, 1, fileProgress);
      }
    },

    // 计算文件进度
    calculateFileProgress(fileProgress) {
      const { totalSize } = fileProgress;
      const { uploadedSize } = fileProgress;
      const percentage = Math.round((uploadedSize / totalSize) * 100);

      // 计算整体上传速度
      let speed = 0;
      if (fileProgress.startTime) {
        const timeDiff = (Date.now() - fileProgress.startTime) / 1000;
        if (timeDiff > 0) {
          speed = uploadedSize / timeDiff;
        }
      }

      const updatedFileProgress = {
        ...fileProgress,
        percentage,
        speed,
      };

      this.updateFileProgressInList(updatedFileProgress);
    },

    // 合并文件切片
    async mergeFileChunks(file, fileMd5, fileProgress) {
      try {
        const {
          ruleCode, taxSeqNo, payPlatForm, payCompany,
        } = this.ruleForm;

        const cancelToken = this.createCancelToken();
        this.uploadControllers.set(`${fileMd5}-merge`, cancelToken.cancel);

        const mergeParams = {
          fileName: file.name,
          fileMd5,
          chunks: fileProgress.chunks.length,
          configCode: this.propsObj.configCode,
          webSocketClientId: this.sid,
          taxSeqNo,
          payPlatForm,
          payCompany,
          ruleCode,
        };

        const response = await request.post(
          '/tax/v1/terminalCash/api/mergeChunks',
          mergeParams,
          {
            cancelToken: cancelToken.token,
          },
        );

        if (response.success) {
          const completedFileProgress = {
            ...fileProgress,
            status: 'completed',
            percentage: 100,
            uploadedSize: file.size,
          };
          this.updateFileProgressInList(completedFileProgress);
        } else {
          throw new Error(response.message || '文件合并失败');
        }
      } catch (error) {
        if (!axios.isCancel(error)) {
          const failedFileProgress = {
            ...fileProgress,
            status: 'error',
          };
          this.updateFileProgressInList(failedFileProgress);
          throw error;
        }
      } finally {
        this.uploadControllers.delete(`${fileMd5}-merge`);
      }
    },

    // 暂停上传
    pauseUpload() {
      this.uploadProgress.isPaused = true;
      this.$message.info('上传已暂停');
    },

    // 继续上传
    resumeUpload() {
      this.uploadProgress.isPaused = false;
      this.$message.info('继续上传');

      // 重新开始上传所有未完成的文件
      const pendingFiles = this.uploadProgress.files.filter(
        (file) => file.status === 'uploading' || file.status === 'paused',
      );

      if (pendingFiles.length > 0) {
        pendingFiles.forEach((fileProgress) => {
          const file = this.files.find((f) => f.uid === fileProgress.uid);
          if (file) {
            if (fileProgress.useChunk) {
              this.uploadChunks(file, '', fileProgress);
            } else {
              this.uploadSingleFile(file, fileProgress);
            }
          }
        });
      }
    },

    // 取消上传
    cancelUpload() {
      this.uploadProgress.isPaused = true;

      // 取消所有进行中的请求
      this.uploadControllers.forEach((cancel, key) => {
        cancel('请求被取消');
      });
      this.uploadControllers.clear();
      this.pendingChunksMap.clear();

      // 更新所有文件状态为已取消
      this.uploadProgress.files = this.uploadProgress.files.map((file) => ({
        ...file,
        status: 'paused',
      }));

      this.uploadLoading = false;
      this.uploadProgress.uploading = false;
      this.$message.info('上传已取消');
    },

    // 重置上传状态
    resetUploadState() {
      this.uploadProgress.visible = false;
      this.uploadProgress.uploading = false;
      this.uploadProgress.isPaused = false;
      this.uploadProgress.files = [];
      this.uploadControllers.clear();
      this.pendingChunksMap.clear();
      this.fileList = [];
      this.files = [];
    },

    // 工具方法
    formatSize(bytes) {
      if (bytes === 0) return '0 B';
      const k = 1024;
      const sizes = ['B', 'KB', 'MB', 'GB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return `${parseFloat((bytes / k ** i).toFixed(2))} ${sizes[i]}`;
    },

    formatSpeed(bytesPerSecond) {
      return `${this.formatSize(bytesPerSecond)}/s`;
    },

    getStatusText(file) {
      const statusMap = {
        pending: '等待上传',
        uploading: '上传中',
        paused: '已暂停',
        completed: '已完成',
        error: '上传失败',
      };
      return statusMap[file.status] || file.status;
    },

    getProgressStatus(file) {
      if (file.status === 'error') return 'exception';
      if (file.status === 'completed') return 'success';
      return null;
    },

    // 原有的文件处理方法
    handleChange(file, fileList) {
      if (file.status === 'ready') {
        const isValid = this.validateFile(file);
        if (!isValid) {
          this.removeInvalidFile(file, fileList);
          return;
        }
      }
      this.updateValidFiles(fileList);
    },

    validateFile(file) {
      const { name, size } = file;
      const fileType = name.split('.').pop().toLowerCase();
      const isLt2G = size / 1024 / 1024 / 1024 <= 2;

      if (fileType !== 'zip') {
        this.$message.error(`文件 "${name}" 不是ZIP格式，请选择ZIP文件`);
        return false;
      }

      if (!isLt2G) {
        this.$message.error(`文件 "${name}" 超过2GB限制`);
        return false;
      }

      return true;
    },

    removeInvalidFile(file, fileList) {
      const index = fileList.findIndex((item) => item.uid === file.uid);
      if (index > -1) {
        fileList.splice(index, 1);
      }
      this.$nextTick(() => {
        this.fileList = [...fileList];
      });
    },

    updateValidFiles(fileList) {
      const validFiles = fileList.filter((item) => item.status !== 'fail');
      this.files = validFiles.map((item) => {
        // 确保每个文件都有uid
        if (!item.uid) {
          item.uid = this.generateUid();
        }
        return item.raw || item;
      });
    },

    generateUid() {
      return Date.now().toString(36) + Math.random().toString(36).substr(2);
    },

    // 其他原有方法保持不变
    dialog_btnClose() {
      this.propsObj.visible = false;
      this.$parent.modalName = null;
      this.propsObj.closeModal();
      this.closeWebSocket();
      this.cancelUpload();
      this.$forceUpdate();
    },

    handleRemove(file) {
      // 移除文件时的处理
      const index = this.files.findIndex((f) => f.uid === file.uid);
      if (index > -1) {
        this.files.splice(index, 1);
      }
    },

    beforeUpload(file) {
      return this.validateFile(file);
    },

    handlePreview(file) {
      console.log(file);
    },

    handleSuccess(res) {
      // 原有的成功处理逻辑
    },

    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 10 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`,
      );
    },

    beforeRemove(file) {
      if (!this.uploadProgress.uploading) {
        return this.$confirm(`确定移除 ${file.name}？`);
      }
      return false;
    },

    // 下载模板
    download_modal() {
      const a = document.createElement('a');
      a.href = `/excel/excelImportController/demoFile?configCode=${
        this.propsObj.configCode
      }&token=${Storage.l.get('TokenKey')}`;
      document.body.appendChild(a);
      a.click(); // 下载
      URL.revokeObjectURL(a.href); // 释放URL 对象
      document.body.removeChild(a); // 删除 a 标签
    },

    // 下载原文件或失败文件
    download_originfile(type) {
      const objectName = type === 'success'
        ? this.propsObj.row.objectName
        : this.propsObj.row.objectNameAsImportFail;
      const a = document.createElement('a');
      a.href = `/upload/downloadController/downloadExcelFile?objectName=${objectName}`;
      document.body.appendChild(a);
      a.click(); // 下载
      URL.revokeObjectURL(a.href); // 释放URL 对象
      document.body.removeChild(a); // 删除 a 标签
    },

    // WebSocket 相关方法
    createWebsocket() {
      if (typeof WebSocket === 'undefined') {
        this.$message.error('您的浏览器不支持socket');
        return;
      }

      const { sid } = this.propsObj;
      this.sid = sid;
      // const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
      const token = Storage.l.get('TokenKey');

      if (!token) {
        console.warn('未找到用户token');
        return;
      }

      console.log(
        `${websocketUrl}/excel/websocket/user?sid=${sid}&&token=${token}`,
      );

      this.websocket = new ReconnectingWebSocket(
        `${websocketUrl}/excel/websocket/user?sid=${sid}&&token=${token}`,
      );

      this.websocket.onerror = this.websocketOnerror;
      this.websocket.onopen = this.websocketOnopen;
      this.websocket.onmessage = (event) => {
        this.websocketOnmessage(event, sid);
      };
      this.websocket.onclose = this.websocketOnclose;
      this.websocket.onbeforeunload = this.websocketOnbeforeunload;
    },

    // 连接发生错误的回调方法
    websocketOnerror() {
      console.log('WebSocket连接发生错误');
    },

    // 连接成功建立的回调方法
    websocketOnopen() {
      console.log('WebSocket连接成功建立');
    },

    // 接收到消息的回调方法
    websocketOnmessage(event) {
      console.log('接收到WebSocket消息:', event);
      const data = JSON.parse(event.data);
      this.propsObj.exportMessage += `${data.message}<br/>`;
      // 滑动条移动到最底部
      this.$nextTick(() => {
        const div = document.getElementsByClassName('modal-scrollbar')[0];
        if (div) {
          div.scrollTop = div.scrollHeight;
        }
      });
    },

    // 连接关闭的回调方法
    websocketOnclose() {
      console.log('WebSocket连接关闭');
    },

    // 监听窗口关闭事件
    websocketOnbeforeunload() {
      this.closeWebSocket();
    },

    // 关闭WebSocket连接
    closeWebSocket() {
      if (this.websocket) {
        this.websocket.close();
        this.websocket = null;
      }
    },

    // 原有的上传方法（保持兼容）
    startUpload(type) {
      this.startUploadProcess();
    },
  },
};
</script>

<style lang="less" scoped>
.upload-section {
  margin: 20px 0;
}
.wsMessageBox{
  min-height: 200px;
  max-height: 300px;
  overflow-y: scroll;
}
.upload-progress {
  margin-top: 20px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 15px;

  .progress-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
    font-weight: bold;
  }

  .file-progress {
    margin-bottom: 15px;
    padding: 10px;
    border: 1px solid #f0f0f0;
    border-radius: 4px;

    .file-info {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 8px;

      .file-name {
        font-weight: 500;
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .file-status {
        color: #909399;
        font-size: 12px;
        margin: 0 8px;
      }

      .upload-mode {
        color: #67c23a;
        font-size: 12px;
        font-style: italic;
      }
    }

    .progress-details {
      .progress-text {
        display: flex;
        justify-content: space-between;
        margin-top: 5px;
        font-size: 12px;
        color: #909399;
      }
    }

    .upload-speed {
      font-size: 12px;
      color: #67c23a;
      margin-top: 5px;
    }
  }
}

.dialog-footer {
  position: absolute;
  bottom: 0;
  right: 20px;
  display: flex;
  justify-content: flex-end;
  width: 100%;
  z-index: 99;
  background-color: white;
  padding: 10px 20px 10px 0;
}

/deep/ .el-upload-dragger,
/deep/ .el-upload {
  width: 100%;
}

.flex {
  display: flex;
  align-items: flex-end;

  .upload-demo {
    flex: 1;
    margin-right: 20px;
  }
}
</style>
